export const langConst = {
    en: {
      search: "Search",
      placeholder: "What do you want to watch today?",
      nowPlaying: "Now Playing",
      seriesTrend: 'Popular Hindi Movies',
      topRated:"Top Rated Movies",
      popular:'Popular'
    },
  
    hin: {
      search: "खोज",
      placeholder: "आज आप क्या देखना चाहते हैं?",
      nowPlaying: "हाल ही में जोड़ा",
      seriesTrend: 'लोकप्रिय हिंदी फिल्में',
      topRated:"सर्वोच्च रेटिंग वाली फ़िल्में",
      popular:'लोकप्रिय'
    },

  };